exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-secret-question-field__secret-heading{margin-top:40px;margin-bottom:12px}.set-secret-question-field__secret-body,.set-secret-question-field__secret-recommend{margin-bottom:12px;font-weight:300}.set-secret-question-field__secret-recommend{font-size:14px}.set-secret-question-field__secret_question_row:not(:first-of-type){margin-top:40px}.set-secret-question-field__secret_question_add{font-size:12px;cursor:pointer;font-weight:300}.set-secret-question-field__secret_question_add:hover{text-decoration:underline}", ""]);

// exports
